import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IUserSummariesState} from "../reducers/user-summaries.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');
export const getUserSummariesState = createSelector(getDbStoreState,(dbStoreState: DbStoreState) => dbStoreState.userSummaries);

export const getUserSummariesToggled = createSelector(getUserSummariesState,
  (state: IUserSummariesState) =>
    state.toggled
);
